export enum PinterestEvent {
  Init = 'init',
  Checkout = 'checkout',
  Lead = 'lead',
  PageVisit = 'pagevisit',
}
